import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";


// FNP-918: the index toolbar, composed here so what this module offers is
// readable in one place (§2).
//
// ⚠️ THIS MODULE IS READ-ONLY, and the empty space where Add and Delete would
// be is deliberate rather than unfinished (§2). Report types are Stripe's
// catalogue of available report formats: the API exposes listReportTypes and
// getReportType only. There is nothing for this app to create, edit or remove,
// so there is no RBAC branch here either — Reload and Filter are permitted to
// anyone who can reach the page.
//
// Stated explicitly because a toolbar with two buttons and no permission check
// looks identical whether it was reasoned about or forgotten. The matching
// notes are in tables/RecordsTable.tsx and hooks/useReportTypesQuery.ts.
//
// Order is [Reload, Filter], matching the sibling modules. Every element
// carries a stable `key`, which is the toolbar contract.
const useTools = () => {
    const tools = [
        <ReloadRecordsButton key='reload'/>,
        <FilterRecordsButton key='filter'/>,
    ];
    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Report Types')}
            tools={useTools()}
        />
    );
};
